import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({

    en: {
        content: "We are committed to creating the personal, relevant, and engaging experiences that Canadians expect.",
        button: 'PDF version',
        link:"https://site-cbc.radio-canada.ca/documents/impact-and-accountability/diversity-inclusion/plan-2021-2023/progress_in_progress_2022-2025_edi_plan.pdf",
        gif:{
            alt:'Lou riding piggyback on Arnaud, two characters from the TV show Lou et Sophie',
            legend: 'Lou et Sophie, ICI TOU.TV'
        },
        vision: {
            title: 'Our vision',
            content: 'By 2025, our unwavering commitment to equity, diversity and inclusion (EDI) in everything we do makes us an inspiring public service media company and employer. As a catalyst for change, we stand strong in our values, creating space for learning, innovation and courageous conversations. We earn trust through inclusive content that connects genuinely with people and their realities.'
            
        },
        who: {
            title: 'An organization-wide commitment',
            content: 'At CBC/Radio-Canada, we know that it will take organization-wide commitment to meaningfully achieve equity, diversity and inclusion in our content and our workforce. All of us — content creators, independent producers, union members, and many others — are working together to ensure that our content truly reflects the diversity of our country. From coast to coast to coast, we are committed to making sure that all people living in Canada feel valued, seen and heard by their public broadcaster.'
        },

    },
    fr: {
        content: "Nous sommes résolus à créer des expériences uniques, pertinentes et engageantes qui répondent aux attentes de la population canadienne.",
        button: 'Version PDF',
        link:"https://site-cbc.radio-canada.ca/documents/impact-and-accountability/diversity-inclusion/plan-2021-2023/cap_sur_le_succes_plan_edi_2022-2025.pdf",
        gif:{
            alt:"Lou à cheval sur Arnaud, deux personnages de l'émission Lou et Sophie.",
            legend: 'Lou et Sophie, ICI TOU.TV'
        },
        vision: {
            title: 'Notre vision',
            content: "D’ici 2025, nous deviendrons un média public et un employeur inspirant, engagé fermement envers l’équité, la diversité et l’inclusion (EDI) dans toutes ses actions. Catalyseurs du changement, nous resterons fidèles à nos valeurs et créerons un espace pour l’apprentissage, l’innovation et les conversations courageuses. Nous gagnerons la confiance de nos auditoires en leur proposant des contenus inclusifs qui leur parlent vraiment et montrent leurs réalités."
            
        },
        who: {
            title: 'Un engagement à l’échelle de l’organisation',
            content: "À CBC/Radio-Canada, nous savons qu’un engagement à l’échelle de l’organisation est nécessaire à l’intégration réussie de l’équité, de la diversité et de l’inclusion dans nos contenus et notre effectif. Nous tous et toutes, que ce soit à la création de contenus, au sein des boîtes de production indépendante et dans le milieu syndical, entre autres, travaillons ensemble pour faire en sorte que nos contenus reflètent réellement toute la diversité de notre pays. Nous nous engageons à ce que toutes les personnes vivant au Canada se sentent valorisées, reconnues et entendues par leur diffuseur public, d’un océan à l’autre."
        },

    }
});

export default strings;